import React, { useRef, useState, useEffect } from "react";

const XAxis = ({ labels, marginLeft, formatTick, barPositions }) => (
  <div className="relative mt-2 min-h-5" style={{ marginLeft }}>
    {barPositions.map((pos, i) => (
      <span
        key={i}
        className="absolute text-xs text-gray-600 font-medium whitespace-nowrap text-center"
        style={{
          left: pos.left - barPositions[0].left,
          width: pos.width,
        }}
      >
        {formatTick ? formatTick(labels[i]) : labels[i]}
      </span>
    ))}
  </div>
);

export default XAxis;
